var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-pagination',{attrs:{"total":_vm.count,"pageTotal":_vm.pageTotal,"perPage":_vm.perPage,"page":_vm.page},on:{"changePage":_vm.changePage}})}
var staticRenderFns = []

export { render, staticRenderFns }